<template>
  <!-- -->
  <div class="list-page">
    <slot/>
    <div v-if="statusName" class="status-name" :class="statusType">{{statusName}}</div>
  </div>
</template>

<script>

export default {
  props: {
    statusName: {default: ""},
    statusType: {default: "primary"}, // 样式，与el相同
  },
  name: "LP",
  components: {
  },
  data() {
    return {
      tagList: [], // 有哪些tag
    };
  },
  created() {
  },
  methods: {
    addTags() {

    },
  }
};
</script>

<style lang="scss" scoped>
//@import "./LayoutShadowBorder";
.list-page{
  height: 100%;
  display: flex;
  flex-direction: column;
  :deep(>.list-table){
    flex: 1;
    height: 50%;
    margin-bottom: 10px;
  }
  :deep(>.search-condition,.detail-form) {
    background: #FFF;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  :deep(>.form-page){
    border-radius: 4px;
  }
  :deep(>*) {
    &.border{// 边框
      border: 1px solid var(--yq-border-color);
    }
    &.shadow{// 阴影
      box-shadow: 0 2px 4px var(--yq-shadow);
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .status-name{ // 状态标签：左侧色条强调
    position: absolute;
    z-index: 1;
    right: 12px;
    top: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 12px;
    line-height: 1;
    font-weight: 500;
    letter-spacing: .5px;
    color: var(--el-color-primary);
    background: color-mix(in srgb, currentColor 8%, #fff); // 浅色底
    box-shadow: inset 3px 0 0 currentColor; // 左侧状态色条

    &.primary{ color: var(--el-color-primary); }
    &.success{ color: var(--el-color-success); }
    &.danger{ color: var(--el-color-danger); }
    &.warning{ color: var(--el-color-warning); }
    &.info{ color: var(--el-color-info); }
  }
}

</style>